import React, { useCallback } from 'react';
import { Backdrop, CircularProgress, SpeedDial, SpeedDialAction, SpeedDialIcon } from '@mui/material';
import { ActionButtonOption, ButtonType } from '../../components/ReportActionsButton';

interface ReportSpeedDialProps {
  isOpen: boolean;
  onOpenChange: React.Dispatch<React.SetStateAction<boolean>>;
  actionsOptions: Record<ButtonType, ActionButtonOption>;
  reportModelId?: number;
  reportLoading: boolean;
  ariaLabel: string;
}

export const ReportSpeedDial: React.FC<ReportSpeedDialProps> = ({
  isOpen,
  onOpenChange,
  actionsOptions,
  reportModelId,
  reportLoading,
  ariaLabel
}) => {
  const handleActionClick = useCallback((type: ButtonType) => {
    actionsOptions[type].onClick();
    onOpenChange(false);
  }, [actionsOptions, onOpenChange]);

  const entries = Object.entries(actionsOptions) as unknown as [ButtonType, ActionButtonOption][];

  return (
    <>
      <Backdrop open={isOpen || reportLoading}
        sx={{
          zIndex: (theme) => reportLoading ? theme.zIndex.speedDial + 1 : theme.zIndex.speedDial,
          display: { xs: 'flex', xl: 'none' }
        }}
      >
        {reportLoading && <CircularProgress />}
      </Backdrop>

      <SpeedDial
        ariaLabel={ariaLabel}
        icon={<SpeedDialIcon />}
        onClose={(event, reason) => {
          if (reason !== 'mouseLeave') {
            onOpenChange(false);
          }
        }}
        onOpen={(e, reson) => reson === 'toggle' ? onOpenChange(true) : undefined}
        open={isOpen}
        sx={{ position: 'fixed', bottom: 16, right: 16, display: { xs: 'flex', xl: 'none' } }}
      >
        {entries.map(([type, action]) => (
          <SpeedDialAction
            key={type}
            icon={action.icon}
            tooltipTitle={action.label}
            tooltipOpen
            onClick={() => handleActionClick(type)}
            sx={{
              display: type === ButtonType.saveAs && !reportModelId ? 'none' : 'flex',
              '& .MuiSpeedDialAction-staticTooltipLabel': {
                minWidth: 'max-content'
              }
            }}
          />
        ))}
      </SpeedDial>
    </>
  );
};
